import { getAttributeValue } from '@theme/dom';
import { HTMLCustomElement } from '@theme/html-custom-element';

class StoreEditorialGallery extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.refs.slider) {
      Object.assign(this.refs.slider, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        autoplay: {
          delay: getAttributeValue(this, 'autoplay-delay', 5000),
        },
        speed: 800,
        pagination: {
          el: this.refs.pagination,
          clickable: true,
          renderBullet: (index, className) =>
            `<span class="${className} text-12-book">${(index + 1).toString().padStart(2, '0')}</span>`,
        },
      });

      this.refs.slider.initialize();
    }
  }
}

if (!customElements.get('store-editorial-gallery'))
  customElements.define('store-editorial-gallery', StoreEditorialGallery);
